import React, { useEffect, useState } from "react"
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Upload,
} from "antd"
import axios from "axios"
import { AXIOS_IP_WATER, convertMomentObjects, generateTempId } from "../filingManagement/fileUploadService"
import { UploadFormItem } from "./UploadFormItem"
import { DateTimeFormatSimpleOnly } from "../../models/datetime"
import moment from "moment"

export const MemberModal = (props: {
  visible: boolean
  token: string
  id?: number
  onOk: (v: any) => void
  onCancel: () => void
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false)

  const [form] = Form.useForm()

  const [data, setData] = useState<any>()

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setData(null)
    } else {
      if(props.id) {
        axios({
          url: `${AXIOS_IP_WATER}/waterHealthArchive/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: {id: props.id},
        }).then((res) => {
          const m = res.data.data
          form.setFieldsValue({
            staffName: m.staffName,
            healthCertExpiryDate: moment(m.healthCertExpiryDate),
            healthCertUrl: m.healthCertUrl || [],
          })
          setData(m)
        })
      }
    }
  }, [props.visible, props.id])

  return (
    <>
      <Modal
        title="管水人员健康证"
        width={800}
        visible={props?.visible}
        confirmLoading={confirmLoading}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setConfirmLoading(true)
              axios({
                url: `${AXIOS_IP_WATER}/waterHealthArchive/saveOrUpdate`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": props.token,
                },
                withCredentials: false,
                method: "POST",
                data: convertMomentObjects({...vs, id: props.id}),
              }).then((res) => {
                props.onOk({
                  id: res.data.data,
                  lastId: props.id,
                  ...vs,
                })
              }).finally(() => {
                setConfirmLoading(false)
              })
            }}
          >
            <Form.Item
              name="staffName"
              label="人员姓名"
              rules={[{ required: true }]}
            >
              <Input allowClear style={{ width: '40%' }} />
            </Form.Item>
            <Form.Item
              name="healthCertExpiryDate"
              label="健康证有效日期"
              rules={[{ required: true }]}
            >
              <DatePicker
                placeholder=" 年 / 月 / 日"
                format={DateTimeFormatSimpleOnly}
                allowClear
                style={{ width: '40%' }}
              />
            </Form.Item>
            <UploadFormItem 
              name="healthCertUrl"
              label="健康证"
              type={2}
              token={props.token}
              required={true}
              maxCount={1}
              defaultValue={data?.healthCertUrl || []}
              changeForm={(v) => form.setFieldsValue({ healthCertUrl: v })}
            />
          </Form>
        </div>
      </Modal>

    </>
  )
}
